<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » コンテンツ購入日次情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>コンテンツ購入日次情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/purchase-content-daily.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 条件ボタン
        </div>
        <div class="manual-explain">
          クリックすることで<a [href]="selectPurchaseDailyDialogLink">コンテンツ購入日次情報検索条件ダイアログ</a>を表示します。<br>
          コンテンツ購入日次情報検索条件ダイアログで検索条件を設定すると、その内容でコンテンツ購入日次情報を検索します。(初期表示時は無条件です)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Filter
        </div>
        <div class="manual-explain">
          コンテンツ購入日次一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、施設、建物・カテゴリ、環境
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> コンテンツ購入日次一覧
        </div>
        <div class="manual-explain">
          コンテンツ購入日次情報の一覧が表示されます。
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Daily Content Purchase Information
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Daily Content Purchase Information</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_purchase-content-daily.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Conditions Button
        </div>
        <div class="manual-explain">
          Click to display the <a [href]="selectPurchaseDailyDialogLink">Daily Content Purchase Information Search Conditions Dialog</a>.<br>
          When search conditions are set in the Daily Content Purchase Information Search Conditions Dialog, daily content purchase information will be searched with those conditions. (No conditions by default)
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the daily content purchase list.<br>
          *Filtering targets: Facility, Building/Category, Environment
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Daily Content Purchase List
        </div>
        <div class="manual-explain">
          Displays a list of daily content purchase information.
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
